import useWindowDimensions from '@src/Common/Hooks/useWindowDimensions';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './SkeletonTimeline.module.scss';
interface ISkeletonTimeline {
  containerWidth?: number;
}
const SkeletonTimeline: React.FC<ISkeletonTimeline> = ({ containerWidth }) => {
  const { width, height } = useWindowDimensions();
  const fullWidth = width;
  const fullHeight = height > 600 ? height * 0.2 : height * 0.3;
  const widthContainer = containerWidth ?? width;
  const gridMargin = (2 / 100) * widthContainer;
  const widthGrid = [
    (1 / 5) * (widthContainer * 2) - gridMargin,
    (3 / 5) * (widthContainer * 2) - gridMargin
  ];

  const sizeCircle = width > 768 ? 240 : 120;
  const circles = Array.from(
    {
      length: Math.round((widthContainer * 2) / sizeCircle) + 1
    },
    (_v, i) => i
  );
  const heightSkeleton = width > 768 ? 16 : 8;

  return (
    <ContentLoader
      uniqueKey="SkeletonTimeline-Default"
      data-testid="SkeletonTimeline-Default"
      speed={2}
      width={widthContainer}
      height={fullHeight}
      viewBox={`0 0 ${fullWidth} 300`}
      backgroundColor="#0e1931"
      foregroundColor="#142e3d"
      className={styles['Container']}
    >
      <rect
        x="0"
        y="56"
        rx="3"
        ry="3"
        width={fullWidth}
        height={heightSkeleton}
      />
      {circles.map((c) => {
        const yPosition = width > 768 ? 64 : 60;
        const xPosition = c === 0 ? 30 : c * sizeCircle + 30;
        const circleSize = width > 768 ? 22 : 11;
        return <circle key={c} cx={xPosition} cy={yPosition} r={circleSize} />;
      })}
      <rect
        x="0"
        y="280"
        rx="3"
        ry="3"
        width={Math.round(widthGrid[0])}
        height={heightSkeleton}
      />
      <rect
        x={Math.round(widthGrid[0] + gridMargin)}
        y="280"
        rx="3"
        ry="3"
        width={Math.round(widthGrid[1])}
        height={heightSkeleton}
      />
      <rect
        x={Math.round(widthGrid[0] + gridMargin + widthGrid[1] + gridMargin)}
        y="280"
        rx="3"
        ry="3"
        width={Math.round(widthGrid[0])}
        height={heightSkeleton}
      />
    </ContentLoader>
  );
};

export default SkeletonTimeline;
